<template>
  <div class="home detail-actions-page">
    <div class="px-8 py-4">
      <!-- Header -->
      <div class="detail-page-header detail-page-title-row d-flex justify-content-between align-items-center mb-4">
        <div>
          <button type="button" class="btn btn-link text-decoration-none detail-page-back" @click="$router.go(-1)" style="padding: 10px 0">
            <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-2" />{{$t('back')}}
          </button>
          <h3 class="detail-page-title mb-0">{{ project.name }}</h3>
        </div>
        <div class="detail-page-actions">
          <button v-if="helper.checkAccess('edit_projects') > 0" @click="editProject" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs detail-page-action--secondary">
            <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
            {{$t('edit')}}
          </button>
          <button v-if="helper.checkAccess('delete_projects') > 0" @click="deleteProject" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs detail-page-action--danger">
            <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
            {{$t('delete')}}
          </button>
        </div>
      </div>

      <!-- Project Info Cards -->
     

      <!-- Tabs -->
      <ul class="nav nav-tabs detail-page-tabs mb-4">
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'overview'}" @click="activeTab = 'overview'">{{$t('overview')}}</a>
        </li>
        <li class="nav-item" v-if="helper.checkAccess('view_tasks') > 0">
          <a class="nav-link" :class="{active: activeTab === 'tasks'}" @click="activeTab = 'tasks'">{{$t('tasks')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'team'}" @click="activeTab = 'team'">{{$t('team')}}</a>
        </li>
        <li class="nav-item" v-if="helper.checkAccess('view_payments') > 0">
          <a class="nav-link" :class="{active: activeTab === 'payments'}" @click="activeTab = 'payments'">{{$t('payments')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{active: activeTab === 'attachments'}" @click="activeTab = 'attachments'">{{$t('attachments')}}</a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div v-if="activeTab === 'overview'">

         <div class="row mb-4">
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <h6 class="text-muted">{{$t('status')}}</h6>
              <span :class="'badge bg-' + getStatusColor(project.status)">{{ $t(project.status) }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <h6 class="text-muted">{{$t('priority')}}</h6>
              <span :class="'badge bg-' + getPriorityColor(project.priority)">{{ $t(project.priority) }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="text-muted mb-0">{{$t('progress')}}</h6>
                <button v-if="!editingProgress && helper.checkAccess('edit_projects') > 0" @click="startEditProgress" class="btn btn-xs btn-link p-0" style="font-size: 12px;">
                  <AppIcon name="bi-pencil" class="bi bi-pencil" />
                </button>
              </div>
              <div v-if="!editingProgress">
                <div class="progress" style="height: 25px;">
                  <div class="progress-bar" :style="{width: project.progress + '%'}">{{ project.progress }}%</div>
                </div>
              </div>
              <div v-else>
                <div class="d-flex gap-2 align-items-center mb-2">
                  <input v-model.number="editProgressValue" type="range" class="form-range" min="0" max="100" step="5" style="flex: 1;">
                  <input v-model.number="editProgressValue" type="number" class="form-control form-control-sm" min="0" max="100" style="width: 70px;">
                </div>
                <div class="d-flex gap-1">
                  <button @click="saveProgress" class="btn btn-success btn-sm flex-grow-1">
                    <AppIcon name="bi-check" class="bi bi-check" /> {{$t('save')}}
                  </button>
                  <button @click="cancelEditProgress" class="btn btn-secondary btn-sm">
                    <AppIcon name="bi-x" class="bi bi-x" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <h6 class="text-muted">{{$t('budget')}}</h6>
              <h5>{{ formatMoney(project.budget || 0) }}</h5>
            </div>
          </div>
        </div>
      </div>
      
        <!-- Project Insights -->
        <div v-if="helper.checkAccess('view_tasks') > 0" class="row mb-4">
          <div class="col-md-3">
            <div class="card insight-card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <small class="text-muted d-block">{{$t('total_tasks')}}</small>
                    <h3 class="mb-0">{{ projectInsights.totalTasks }}</h3>
                  </div>
                  <div class="insight-icon bg-primary bg-opacity-10 text-primary">
                    <AppIcon name="bi-list-check" class="bi bi-list-check" style="font-size: 24px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card insight-card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <small class="text-muted d-block">{{$t('completed_tasks')}}</small>
                    <h3 class="mb-0">{{ projectInsights.completedTasks }}</h3>
                  </div>
                  <div class="insight-icon bg-success bg-opacity-10 text-success">
                    <AppIcon name="bi-check-circle" class="bi bi-check-circle" style="font-size: 24px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card insight-card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <small class="text-muted d-block">{{$t('in_progress')}}</small>
                    <h3 class="mb-0">{{ projectInsights.inProgressTasks }}</h3>
                  </div>
                  <div class="insight-icon bg-warning bg-opacity-10 text-warning">
                    <AppIcon name="bi-hourglass-split" class="bi bi-hourglass-split" style="font-size: 24px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card insight-card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <small class="text-muted d-block">{{$t('team_members')}}</small>
                    <h3 class="mb-0">{{ projectInsights.teamMembers }}</h3>
                  </div>
                  <div class="insight-icon bg-info bg-opacity-10 text-info">
                    <AppIcon name="bi-people" class="bi bi-people" style="font-size: 24px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Left Column: Description & Timeline -->
          <div class="col-md-8">
            <!-- Description Card -->
            <div class="card mb-4">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-file-text" class="bi bi-file-text me-2" />{{$t('description')}}</h6>
              </div>
              <div class="card-body">
                <p class="mb-0">{{ project.description || $t('no_description') }}</p>
              </div>
            </div>

            <!-- Timeline Card -->
            <div class="card mb-4">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-clock-history" class="bi bi-clock-history me-2" />{{$t('project_timeline')}}</h6>
              </div>
              <div class="card-body">
                <div class="timeline">
                  <div class="timeline-item">
                    <div class="timeline-marker bg-primary"></div>
                    <div class="timeline-content">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="mb-1">{{$t('project_start')}}</h6>
                          <p class="text-muted small mb-0">{{ formatDate(project.start_date) }}</p>
                        </div>
                        <span class="badge bg-primary">{{$t('planned')}}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="project.actual_start_date" class="timeline-item">
                    <div class="timeline-marker bg-success"></div>
                    <div class="timeline-content">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="mb-1">{{$t('actual_start')}}</h6>
                          <p class="text-muted small mb-0">{{ formatDate(project.actual_start_date) }}</p>
                        </div>
                        <span class="badge bg-success">{{$t('actual')}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="timeline-item">
                    <div class="timeline-marker" :class="project.status === 'completed' ? 'bg-success' : 'bg-secondary'"></div>
                    <div class="timeline-content">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="mb-1">{{$t('current_status')}}</h6>
                          <p class="text-muted small mb-0">{{ $t(project.status) }} - {{ project.progress }}% {{$t('complete')}}</p>
                        </div>
                        <span :class="'badge bg-' + getStatusColor(project.status)">{{ $t(project.status) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="timeline-item">
                    <div class="timeline-marker bg-warning"></div>
                    <div class="timeline-content">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="mb-1">{{$t('planned_end')}}</h6>
                          <p class="text-muted small mb-0">{{ formatDate(project.end_date) }}</p>
                        </div>
                        <span class="badge bg-warning">{{$t('target')}}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="project.actual_end_date" class="timeline-item">
                    <div class="timeline-marker bg-success"></div>
                    <div class="timeline-content">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="mb-1">{{$t('actual_end')}}</h6>
                          <p class="text-muted small mb-0">{{ formatDate(project.actual_end_date) }}</p>
                        </div>
                        <span class="badge bg-success">{{$t('completed')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notes Card -->
            <div v-if="project.notes" class="card">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-sticky" class="bi bi-sticky me-2" />{{$t('notes')}}</h6>
              </div>
              <div class="card-body">
                <p class="mb-0">{{ project.notes }}</p>
              </div>
            </div>
          </div>

          <!-- Right Column: Quick Info -->
          <div class="col-md-4">
            <!-- Dates Card -->
            <div class="card mb-4">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-calendar-event" class="bi bi-calendar-event me-2" />{{$t('important_dates')}}</h6>
              </div>
              <div class="card-body">
                <div class="mini-timeline">
                  <div class="mini-timeline-item">
                    <div class="mini-timeline-marker bg-primary"></div>
                    <div class="mini-timeline-content">
                      <small class="text-muted d-block">{{$t('start_date')}}</small>
                      <strong class="d-block">{{ formatDate(project.start_date) }}</strong>
                    </div>
                  </div>
                  
                  <div v-if="project.actual_start_date" class="mini-timeline-item">
                    <div class="mini-timeline-marker bg-success"></div>
                    <div class="mini-timeline-content">
                      <small class="text-muted d-block">{{$t('actual_start_date')}}</small>
                      <strong class="d-block text-success">{{ formatDate(project.actual_start_date) }}</strong>
                    </div>
                  </div>

                  <div class="mini-timeline-item">
                    <div class="mini-timeline-marker bg-warning"></div>
                    <div class="mini-timeline-content">
                      <small class="text-muted d-block">{{$t('end_date')}}</small>
                      <strong class="d-block">{{ formatDate(project.end_date) }}</strong>
                    </div>
                  </div>
                  
                  <div v-if="project.actual_end_date" class="mini-timeline-item">
                    <div class="mini-timeline-marker bg-success"></div>
                    <div class="mini-timeline-content">
                      <small class="text-muted d-block">{{$t('actual_end_date')}}</small>
                      <strong class="d-block text-success">{{ formatDate(project.actual_end_date) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Team Members Preview -->
            <div class="card mb-4">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-people" class="bi bi-people me-2" />{{$t('team_members')}}</h6>
              </div>
              <div class="card-body">
                <div v-if="project.assignments && project.assignments.length">
                  <div v-for="assignment in project.assignments.slice(0, 5)" :key="assignment.id" class="d-flex align-items-center mb-2">
                    <div class="avatar-circle me-2">
                      <AppIcon name="bi-person" class="bi bi-person" />
                    </div>
                    <div class="flex-grow-1">
                      <small class="d-block"><strong>{{ assignment?.user?.name }}</strong></small>
                      <small class="text-muted">{{ assignment.role }}</small>
                    </div>
                  </div>
                  <div v-if="project.assignments.length > 5" class="text-center mt-2">
                    <small class="text-muted">+{{ project.assignments.length - 5 }} {{$t('more')}}</small>
                  </div>
                </div>
                <p v-else class="text-muted small mb-0">{{$t('no_team_members')}}</p>
              </div>
            </div>

            <!-- Client Card -->
            <div class="card mb-4" v-if="project.client">
              <div class="card-header bg-white">
                <h6 class="mb-0"><AppIcon name="bi-person-badge" class="bi bi-person-badge me-2" />{{$t('client')}}</h6>
              </div>
              <div class="card-body">
                <h6 class="mb-2">{{ project.client.name }}</h6>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="activeTab === 'tasks' && helper.checkAccess('view_tasks') > 0" class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex align-items-center">
              <h5 class="mb-0">{{$t('tasks')}}</h5>
            </div>
            <button v-if="helper.checkAccess('create_tasks') > 0" @click="openTaskModal = true" class="btn-sm btn btn-success">
              <span class="d-inline-block me-2 .text-primary-dark">
                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
              </span>
              <span>{{$t('task')}}</span>
            </button>
          </div>
          
          <!-- List View -->
          <task-list 
            v-if="taskView === 'list'" 
            :projectId="project.id" 
            :tasks="project.tasks"
            @refresh="loadProject"
            @deleted="removeTask"
          ></task-list>
          
          <!-- Kanban View -->
          <task-kanban 
            v-if="taskView === 'kanban'" 
            :projectId="project.id"
            :tasks="project.tasks"
            @refresh="loadProject"
          ></task-kanban>
          
          <!-- Calendar View -->
          <task-calendar 
            v-if="taskView === 'calendar'" 
            :projectId="project.id"
            :tasks="project.tasks"
            @refresh="loadProject"
          ></task-calendar>
        </div>
      </div>

      <div v-if="activeTab === 'team'" class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5>{{$t('team_members')}}</h5>
            <button v-if="helper.checkAccess('edit_projects') > 0" @click="openTeamModal = true" class="btn-sm btn btn-success">
              <span class="d-inline-block me-2 .text-primary-dark">
                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
              </span>
              <span>{{$t('member')}}</span>
            </button>
          </div>
          <team-list :projectId="project.id" :assignments="project.assignments" @refresh="loadProject" @removed="removeAssignment"></team-list>
        </div>
      </div>

      <div v-if="activeTab === 'payments' && helper.checkAccess('view_payments') > 0">
        <payment-component 
          :openCreateModal="openPaymentModal"
          :paymentable_id="project.id"
          :paymentable_type="'project'"
          :client_id="project.client_id"
          @modalClosed="openPaymentModal = false"
        ></payment-component>
      </div>

      <div v-if="activeTab === 'attachments'">
        <attachments v-if="project && project.id" :entity_id="project.id" entity_type="project" />
      </div>
    </div>

    <!-- Modals -->
    <add-task-modal v-if="openTaskModal" :projectId="project.id" @close="openTaskModal = false" @refresh="loadProject"></add-task-modal>
    <add-team-modal v-if="openTeamModal" :projectId="project.id" :existingAssignments="project.assignments || []" @close="openTeamModal = false" @refresh="loadProject"></add-team-modal>
    <add-edit-project-modal v-if="openEditModal" :isModalOpen="openEditModal" :data="project" action="update" @modalClosed="openEditModal = false" @refresh="openEditModal = false; loadProject()"></add-edit-project-modal>
  </div>
</template>

<script>
import helper from '../../helper'
import TaskList from '../../components/project/TaskList.vue'
import TaskKanban from '../../components/project/TaskKanban.vue'
import TaskCalendar from '../../components/project/TaskCalendar.vue'
import TeamList from '../../components/project/TeamList.vue'
import AddTaskModal from '../../components/project/AddTaskModal.vue'
import AddTeamModal from '../../components/project/AddTeamModal.vue'
import AddEditProjectModal from '../../components/project/AddEditProjectModal.vue'
import PaymentComponent from '../../components/PaymentComponent.vue'
import Attachments from '../../components/Attachment.vue'

export default {
  name: 'ProjectDetails',
  components: {
    TaskList,
    TaskKanban,
    TaskCalendar,
    TeamList,
    AddTaskModal,
    AddTeamModal,
    AddEditProjectModal,
    PaymentComponent,
    Attachments
  },
  data() {
    return {
      helper,
      project: {
        assignments: [],
        attachments: [],
        tasks: [],
        payments: []
      },
      activeTab: 'overview',
      taskView: 'kanban',
      openTaskModal: false,
      openTeamModal: false,
      openEditModal: false,
      openPaymentModal: false,
      editingProgress: false,
      editProgressValue: 0
    }
  },
  computed: {
    projectInsights() {
      const tasks = this.project.tasks || []
      return {
        totalTasks: tasks.length,
        completedTasks: tasks.filter(t => t.status === 'completed').length,
        inProgressTasks: tasks.filter(t => t.status === 'in_progress').length,
        teamMembers: this.project.assignments ? this.project.assignments.length : 0
      }
    }
  },
  mounted() {
    //check permissions
    if(helper.checkAccess('view_projects') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_projects') == -2) return this.$router.push({path : '/subscribe'})

    window.mixpanel.track("project_details");
    this.loadProject()
  },
  methods: {
    removeTask(taskId) {
      this.project.tasks = helper.withoutDeletedRecords(this.project.tasks, taskId)
    },
    removeAssignment(userId) {
      this.project.assignments = this.project.assignments.filter(assignment => String(assignment.user_id) !== String(userId))
    },
    formatMoney(number) { return helper.formatMoney(number);},
    async loadProject() {
      try {
        const response = await helper.customGet(`${process.env.VUE_APP_API}/projects/${this.$route.params.id}`)
        this.project = response.data
      } catch (error) {
        alert('Error loading project:', error)
      }
    },
    getStatusColor(status) {
      const colors = {
        draft: 'secondary',
        active: 'primary',
        on_hold: 'warning',
        completed: 'success',
        cancelled: 'danger'
      }
      return colors[status] || 'secondary'
    },
    getPriorityColor(priority) {
      const colors = {
        low: 'info',
        medium: 'primary',
        high: 'warning',
        urgent: 'danger'
      }
      return colors[priority] || 'primary'
    },
    formatDate(date) {
      if (!date) return this.$t('not_set')
      return new Date(date).toLocaleDateString()
    },
    editProject() {
      if (helper.checkAccess('edit_projects') <= 0) return
      this.openEditModal = true
    },
    async deleteProject() {
      if (helper.checkAccess('delete_projects') <= 0) return
      const result = await this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      })
      if (result.isConfirmed) {
        try {
          await helper.customDelete(`${process.env.VUE_APP_API}/projects/${this.project.id}`)
          this.$router.push('/projects')
        } catch (error) {
          alert('Error deleting project:', error)
        }
      }
    },
    startEditProgress() {
      if (helper.checkAccess('edit_projects') <= 0) return
      this.editProgressValue = this.project.progress
      this.editingProgress = true
    },
    async saveProgress() {
      if (helper.checkAccess('edit_projects') <= 0) return
      try {
        const progress = Math.min(100, Math.max(0, this.editProgressValue))
        await helper.customPatch(`${process.env.VUE_APP_API}/projects/${this.project.id}`, {
          progress: progress
        }, { showToast: true })
        this.editingProgress = false
        await this.loadProject()
      } catch (error) {
        alert('Error updating progress:', error)
      }
    },
    cancelEditProgress() {
      this.editProgressValue = this.project.progress
      this.editingProgress = false
    }
  }
}
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}

/* Insight Cards */
.insight-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.insight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.insight-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Timeline Styles */
.timeline {
  position: relative;
  padding-left: 30px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #0d6efd, #198754);
}

.timeline-item {
  position: relative;
  margin-bottom: 30px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -26px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #e9ecef;
}

.timeline-content {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 3px solid #0d6efd;
  transition: all 0.2s;
}

.timeline-content:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.timeline-content h6 {
  font-size: 14px;
  margin-bottom: 5px;
}

/* Avatar Circle */
.avatar-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

/* Date Item */
.date-item {
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #0d6efd;
}

/* Mini Timeline for Dates */
.mini-timeline {
  position: relative;
  padding-left: 25px;
}

.mini-timeline::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: linear-gradient(to bottom, #0d6efd, #ffc107, #198754);
}

.mini-timeline-item {
  position: relative;
  margin-bottom: 20px;
  padding-left: 5px;
}

.mini-timeline-item:last-child {
  margin-bottom: 0;
}

.mini-timeline-marker {
  position: absolute;
  left: -21px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #e9ecef;
}

.mini-timeline-content {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.2s;
}

.mini-timeline-content:hover {
  background: #e9ecef;
  transform: translateX(3px);
}

.mini-timeline-content small {
  font-size: 11px;
  margin-bottom: 2px;
}

.mini-timeline-content strong {
  font-size: 13px;
}

/* Card Headers */
.card-header {
  border-bottom: 2px solid #f0f0f0;
}

.card-header h6 {
  color: #495057;
  font-weight: 600;
}
</style>
